import { DndContext, closestCenter, PointerSensor, KeyboardSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, arrayMove, rectSortingStrategy, sortableKeyboardCoordinates, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { SiteTile } from "@/components/SiteTile";

function SortableTile({ site, index, isAdmin, onEdit, disabled }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: site.id, disabled });
  const style = { transform: CSS.Transform.toString(transform), transition, zIndex: isDragging ? 40 : undefined };
  return (
    <div ref={setNodeRef} style={style} className={isDragging ? "opacity-80 scale-[1.02]" : ""}>
      <SiteTile site={site} index={index} isAdmin={isAdmin} onEdit={onEdit}
        dragHandle={isAdmin && !disabled ? { ...attributes, ...listeners } : null} />
    </div>
  );
}

export const SortableGrid = ({ sites, isAdmin, disabled, onEdit, onReorder, testId = "sites-grid" }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    const from = sites.findIndex((s) => s.id === active.id);
    const to = sites.findIndex((s) => s.id === over.id);
    onReorder(arrayMove(sites, from, to));
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <SortableContext items={sites.map((s) => s.id)} strategy={rectSortingStrategy}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5" data-testid={testId}>
          {sites.map((s, i) => (
            <SortableTile key={s.id} site={s} index={i} isAdmin={isAdmin} disabled={disabled} onEdit={() => onEdit(s)} />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
};
